import React, { useState } from 'react';

import ModalWrapper from './ModalWrapper';

export default function EditStockModal({ item, setEditModal, setItems, getClientOptions }) {
  const clientId = item.clientId;
  const descOptions = getClientOptions('descriptions', clientId);
  const variantOptions = getClientOptions('variants', clientId);
  const [desc, setDesc] = useState(descOptions.includes(item.mainCategory) ? item.mainCategory : 'new');
  const [customDesc, setCustomDesc] = useState(descOptions.includes(item.mainCategory) ? '' : item.mainCategory);
  const [variant, setVariant] = useState(variantOptions.includes(item.variantDesc) ? item.variantDesc : 'new');
  const [customVariant, setCustomVariant] = useState(variantOptions.includes(item.variantDesc) ? '' : item.variantDesc);
  const [editState, setEditState] = useState({
    productCode: item.productCode,
    barcode: item.barcode || '',
    labelSize: item.labelSize || '',
    minQty: item.minQty,
    currentQty: item.currentQty,
    cost: item.cost,
    notes: item.notes || '',
  });

  function handleEditFieldChange(e) {
    const { name, value } = e.target;
    setEditState(m => ({ ...m, [name]: value }));
  }

  function handleDescChange(e) {
    setDesc(e.target.value);
    setCustomDesc('');
  }
  function handleCustomDescChange(e) {
    setCustomDesc(e.target.value);
  }
  function handleVariantChange(e) {
    setVariant(e.target.value);
    setCustomVariant('');
  }
  function handleCustomVariantChange(e) {
    setCustomVariant(e.target.value);
  }

  function handleEditSubmitModal(e) {
    e.preventDefault();
    const mainCategory = desc === 'new' ? customDesc : desc;
    const variantDesc = variant === 'new' ? customVariant : variant;
    if (!editState.cost || isNaN(editState.cost) || Number(editState.cost) <= 0) {
      alert('Cost must be a positive number (R/1000).');
      return;
    }
    fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:4001'}/items/${item.id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ...item,
        ...editState,
        cost: Number(editState.cost),
        mainCategory,
        variantDesc,
        minQty: Number(editState.minQty),
        // currentQty is NOT editable
        clientId: item.clientId,
      })
    })
      .then(res => {
        if (!res.ok) throw new Error('Failed to update item');
        return res.json();
      })
      .then(updated => {
        setItems(items => items.map(i => i.id === updated.id ? updated : i));
        setEditModal({ open: false, item: null });
      })
      .catch(err => alert('Error updating item: ' + err.message));
  }

  return (
    <ModalWrapper open={true} onClose={()=>setEditModal({open:false,item:null})} zIndex={30} minWidth={370} maxWidth={420}>
      <form onSubmit={handleEditSubmitModal} style={{
        background: 'linear-gradient(135deg, #f8fafc 70%, #e3f2fd 100%)',
        padding: 0,
        borderRadius: 0,
        minWidth: 'unset',
        maxWidth: 'unset',
        maxHeight: '90vh',
        overflowY: 'auto',
        boxShadow: 'none',
        display: 'flex',
        flexDirection: 'column',
        gap: 0
      }}>
        <h2 style={{marginBottom: 8, fontWeight: 700, color: '#1976d2', letterSpacing: 1}}>Edit Stock Item</h2>
        <div style={{display:'flex', flexDirection:'column', gap:18}}>
          <div style={{display:'flex', gap:16}}>
            <div style={{flex:1, display:'flex', flexDirection:'column', gap:6}}>
              <label style={{fontWeight:500,marginBottom:2}}>Description</label>
              <select name="mainCategory" value={desc} onChange={handleDescChange} required style={{padding:10, borderRadius:6, border:'1px solid #bdbdbd'}}>
                <option value="">Select Description</option>
                <option value="new">New...</option>
                {descOptions.map((d) => <option key={d} value={d}>{d}</option>)}
              </select>
              {desc === 'new' && (
                <input name="customDescription" value={customDesc} onChange={handleCustomDescChange} placeholder="Enter new description" required style={{padding:10, borderRadius:6, border:'2px solid #1976d2'}} />
              )}
            </div>
            <div style={{flex:1, display:'flex', flexDirection:'column', gap:6}}>
            </div>
          </div>
          <div style={{ display: 'flex', gap: 16 }}>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 6 }}>
              <label style={{ fontWeight: 500, marginBottom: 2 }}>Variant</label>
              <select name="variantDesc" value={variant} onChange={handleVariantChange} required style={{ padding: 10, borderRadius: 6, border: '1px solid #bdbdbd' }}>
                <option value="">Select Variant</option>
                <option value="new">New...</option>
                {variantOptions.map((v) => <option key={v} value={v}>{v}</option>)}
              </select>
              {variant === 'new' && (
                <input name="customVariant" value={customVariant} onChange={handleCustomVariantChange} placeholder="Enter new variant" required style={{ padding: 10, borderRadius: 6, border: '2px solid #1976d2' }} />
              )}
            </div>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 6 }}>
              <label style={{ fontWeight: 500, marginBottom: 2 }}>Price (R/1000) <span style={{ color: 'red' }}>*</span></label>
              <input name="cost" value={editState.cost} onChange={handleEditFieldChange} placeholder="e.g. 1200" type="number" min="0" step="0.01" required style={{ padding: 10, borderRadius: 6, border: '1px solid #bdbdbd' }} />
            </div>
          </div>
          <div style={{ display: 'flex', gap: 16 }}>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 6 }}>
              <label style={{ fontWeight: 500, marginBottom: 2 }}>Barcode</label>
              <input name="barcode" value={editState.barcode} onChange={handleEditFieldChange} placeholder="Barcode" style={{ padding: 10, borderRadius: 6, border: '1px solid #bdbdbd' }} />
            </div>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 6 }}>
              <label style={{ fontWeight: 500, marginBottom: 2 }}>Notes</label>
              <input name="notes" value={editState.notes || ''} onChange={handleEditFieldChange} placeholder="Optional notes about this item" style={{ padding: 10, borderRadius: 6, border: '1px solid #bdbdbd' }} />
            </div>
          </div>
          <div style={{display:'flex', gap:16}}>
            <div style={{flex:1, display:'flex', flexDirection:'column', gap:6}}>
              <label style={{fontWeight:500,marginBottom:2}}>Label Size</label>
              <input name="labelSize" value={editState.labelSize} onChange={handleEditFieldChange} placeholder="Label Size" required style={{padding:10, borderRadius:6, border:'1px solid #bdbdbd'}} />
            </div>
            <div style={{flex:1, display:'flex', flexDirection:'column', gap:6}}>
              <label style={{fontWeight:500,marginBottom:2}}>Min Qty</label>
              <input name="minQty" value={editState.minQty} onChange={handleEditFieldChange} placeholder="Min Qty" type="number" required style={{padding:10, borderRadius:6, border:'1px solid #bdbdbd'}} />
            </div>
          </div>
          <div style={{display:'flex', gap:16}}>
            <div style={{flex:1, display:'flex', flexDirection:'column', gap:6}}>
              <label style={{fontWeight:500,marginBottom:2}}>Current Qty</label>
              <input name="currentQty" value={item.currentQty} disabled placeholder="Current Qty" type="number" style={{padding:10, borderRadius:6, border:'1px solid #bdbdbd', background:'#eee'}} />
            </div>
            <div style={{flex:1}}></div>
          </div>
        </div>
        <div style={{display:'flex',gap:16,justifyContent:'center',marginTop:18}}>
          <button type="submit" style={{background:'#1976d2',color:'white',fontWeight:600,padding:'10px 32px',border:'none',borderRadius:8,boxShadow:'0 2px 8px #1976d233',fontSize:16}}>Save</button>
          <button type="button" onClick={()=>setEditModal({open:false,item:null})} style={{background:'#fff',color:'#1976d2',fontWeight:600,padding:'10px 32px',border:'1.5px solid #1976d2',borderRadius:8,fontSize:16}}>Cancel</button>
        </div>
      </form>
    </ModalWrapper>
  );
}
